import NetworkSetting from './networkSetting';

export default NetworkSetting;